import React, { useEffect, useState } from 'react';

const MusicCursor = () => {
  const [particles, setParticles] = useState([]);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({ x: e.clientX, y: e.clientY });
      
      // Create particle on movement - less frequent
      if (Math.random() > 0.65) {
        const newParticle = {
          id: Date.now() + Math.random(),
          x: e.clientX + (Math.random() - 0.5) * 15,
          y: e.clientY + (Math.random() - 0.5) * 15,
          type: Math.random() > 0.4 ? 'note' : 'dot',
        };
        
        setParticles(prev => [...prev.slice(-8), newParticle]);
        
        // Remove particle after animation
        setTimeout(() => {
          setParticles(prev => prev.filter(p => p.id !== newParticle.id));
        }, 800);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  if (prefersReducedMotion) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-[9999]" aria-hidden="true">
      {/* Subtle cursor glow */}
      <div 
        className="absolute w-6 h-6 -translate-x-1/2 -translate-y-1/2 rounded-full transition-opacity duration-150"
        style={{
          left: mousePos.x,
          top: mousePos.y,
          background: 'radial-gradient(circle, rgba(139, 92, 246, 0.25) 0%, transparent 70%)',
        }}
      />
      
      {/* Smaller particles */}
      {particles.map(particle => (
        <div
          key={particle.id}
          className="absolute animate-cursor-particle"
          style={{
            left: particle.x,
            top: particle.y,
          }}
        >
          {particle.type === 'note' ? (
            <svg 
              className="w-2.5 h-2.5 text-purple-400"
              viewBox="0 0 24 24" 
              fill="currentColor"
              style={{ opacity: 0.6 }}
            >
              <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
            </svg>
          ) : (
            <div className="w-1 h-1 rounded-full bg-indigo-300" style={{ opacity: 0.5 }} />
          )}
        </div>
      ))}
    </div>
  );
};

export default MusicCursor;
